import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bulkInput", "emailList", "emailInput", "removeButton"]

  handlePaste(event) {
    // Small delay to let paste complete
    setTimeout(() => {
      this.parseBulkInput()
    }, 10)
  }

  handleBlur(event) {
    if (event.target === this.bulkInputTarget) {
      this.parseBulkInput()
    }
  }

  handleEmailBlur(event) {
    const input = event.target
    const value = input.value.trim()

    // Split if value contains delimiters and would produce multiple emails
    if ((value.includes(",") || value.includes(" ")) && value.split(/[,\s]+/).length > 1) {
      // Split multiple emails
      const emails = this.parseEmails(value)
      const originalEmail = emails[0]

      // Update current field with first email
      input.value = originalEmail

      // Add remaining emails as new fields
      emails.slice(1).forEach(email => {
        if (email.trim()) {
          this.addEmailField(email.trim())
        }
      })
    }
  }

  removeEmail(event) {
    event.preventDefault()
    event.stopPropagation()

    // Handle click on button or its text content
    const button = event.target.closest("button")
    if (button) {
      // Find the parent container (the div with class "flex items-center gap-2")
      const fieldContainer = button.parentElement
      if (fieldContainer && fieldContainer.classList.contains("flex")) {
        fieldContainer.remove()
      }
    }
  }

  parseBulkInput() {
    const value = this.bulkInputTarget.value.trim()
    if (!value) return

    const emails = this.parseEmails(value)

    // Clear bulk input
    this.bulkInputTarget.value = ""

    // Add each email as a field
    emails.forEach(email => {
      const trimmed = email.trim()
      if (trimmed) {
        // Check if email already exists
        const existingEmails = Array.from(this.emailInputTargets).map(input => input.value.trim())
        if (!existingEmails.includes(trimmed)) {
          this.addEmailField(trimmed)
        }
      }
    })
  }

  parseEmails(text) {
    // Split by comma or whitespace, filter out empty strings
    return text.split(/[,\s]+/).filter(email => email.trim().length > 0)
  }

  addEmailField(email = "") {
    const container = document.createElement("div")
    container.className = "flex items-center gap-2"

    const input = document.createElement("input")
    input.type = "email"
    input.name = "emails[]"
    input.value = email
    input.className = "flex-1 border rounded px-3 py-2 bg-background"
    input.setAttribute("data-email-list-target", "emailInput")
    input.setAttribute("data-action", "blur->email-list#handleEmailBlur")

    const button = document.createElement("button")
    button.type = "button"
    button.className = "px-3 py-2 text-red-600 hover:text-red-800"
    button.setAttribute("data-action", "click->email-list#removeEmail")
    button.setAttribute("data-email-list-target", "removeButton")
    button.textContent = "×"

    container.appendChild(input)
    container.appendChild(button)
    this.emailListTarget.appendChild(container)
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}

